import { pageFactory } from "./factory";
import { vnAppZone } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone";
import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";

import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { pagination_template } from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import { validationsList_template } from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {transactionsPaymentList_template} from "../components/templates/transactionsPaymentList_template";
import {transactionsPaymentSummary_template} from "../components/templates/transactionsPaymentSummary_template";
import { downloadCSV } from "../../vendor/valnet/valnet_jslib/vnHelpers/helper_functions";
import {appHeader_template} from "../components/templates/appHeader_template";
import {header} from "./header";

declare var ko: any;
declare var page: any;

export class transactions_payment_summary extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected elementsList: transactionsPaymentSummary_template;

    protected getModuleName(){
        return "transactions_payment_summary";
    }

    buildContent() : Array<Element>{

        this.elementsList = new transactionsPaymentSummary_template("list", this.viewModel, this);
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Payment Summary");

        return [this.elementsList.build()];
    }

    public fillPage() : void{

        this.filterList();
    }

    protected paginationOnPageClick(){
        this.filterList();
    }

    protected filterSimpleOnChange(){
        // on keywords filtering, always set the page back to 1.
        //
        // this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleCancel(){

    }

    protected showPrintView(id){
        page('/brand/' + this.getVnAppZone().app.params.idBrand + '/payment/documents/summary-printable/'+id);
    }

    protected filterList(){

        // LOADING : starts
        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = {
            filterPayment: {
                payment: this.viewModel.list.idPayment
            }
        };

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/transactions/payments/summary';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push( ["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        let localCheck = this.XHRHdl.requestId;
        let _myThis = this;
        setTimeout(function(){

            if( localCheck == _myThis.XHRHdl.requestId ){
                _myThis.XHRHdl.onReadyStateFunction = _myThis.onFilterRequestReturn;
                _myThis.XHRHdl.execute();
            }
        }, 400);
    }

    protected onFilterRequestReturn(req, obj){

        return function(){

            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response);
                let data = responseParsed.data;

                if(  req.request.status == 200  ){
                    obj.elementsList.validationsList.clearMessages();

                    obj.updateList(data);
                } else if(  req.request.status == 423  ){
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, responseParsed.message);
                    obj.getVnAppZone().showNotificationToModule();
                    page.redirect('/brand/' + obj.getVnAppZone().app.params.idBrand + '/home');
                }
                else{
                    obj.onUpdateError(req.request.status, responseParsed);
                }

                // LOADING : ends
                obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));
            }
        }
    }

    //
    // update the module list using the objects list
    protected updateList(responseParsed: any){

        // set users list
        let users = [];
        if(responseParsed.users) {
            for (var key in responseParsed.users) {
                let item = responseParsed.users[key];
                var total = (item.total < 0) ? '$0.00 ($' + item.total.toLocaleString(undefined, {minimumFractionDigits: 2}) + ')' : '$' + item.total.toLocaleString(undefined, {minimumFractionDigits: 2});

                users.push({
                    total: total
                    , user_id: item.user_id
                    , user_fullName: item.user_fullName
                    , paymentEmail: item.paymentEmail
                    , paymentMethod: item.paymentMethod
                    , paymentDate: item.paymentDate
                    , currency: item.currency
                    , transactions: []
                    , showDetails: false
                })
            }
        }
        this.elementsList.setUsers(users);
        this.elementsList.setPayments(responseParsed.payments);
    }


    protected getUserPaymentDetails(id){

        // LOADING : starts
        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = {
            idPayment: this.viewModel.list.idPayment,
            idUser: id
        };

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/transactions/payments/user/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push( ["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        let localCheck = this.XHRHdl.requestId;
        let _myThis = this;
        setTimeout(function(){

            if( localCheck == _myThis.XHRHdl.requestId ){
                _myThis.XHRHdl.onReadyStateFunction = _myThis.onTransactionRequestReturn;
                _myThis.XHRHdl.execute();
            }
        }, 400);
    }

    protected onTransactionRequestReturn(req, obj){

        return function(){

            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response);
                let data = responseParsed.data;
                if(  req.request.status == 200  ){
                    obj.elementsList.validationsList.clearMessages();

                    obj.updateUserTransactions(data);
                }
                else{
                    obj.onUpdateError(req.request.status, responseParsed);
                }

                // LOADING : ends
                obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));
            }
        }
    }


    //
    // update the list of transactions for the specified user
    protected updateUserTransactions(responseParsed: any){

        // set users list
        let users = this.viewModel.list.users();
        let idUser = responseParsed.user;
        let index = users.map(function(x) {return x.user_id; }).indexOf(idUser);

        for (let item of responseParsed.transactions) {

            var project_name, amount, dateCreation, idYoutube;
            var entry_type = item.entry_type;

            if (item.action_type_id == 3 || item.project_name == null){
                project_name = "N/A";
            }
            else{
                project_name = item.project_name.substring(0,40) + '...';
            }

            if (item.action_type_id == 2){
                entry_type = "Reversal of " + entry_type;
            }

            amount = (item.idType == 1) ? '-$' + Number(item.amount).toLocaleString(undefined, {minimumFractionDigits: 2}): '$' + Number(item.amount).toLocaleString(undefined, {minimumFractionDigits: 2});
            dateCreation = item.dateCreation.substring(0,10);

            users[index].transactions.push( {
                 entry_type: entry_type
                ,project_name: project_name
                ,dateCreation: dateCreation
                ,amount: amount
            });
        }
        this.elementsList.setUsers([]);
        this.elementsList.setUsers(users);
    }

    public exportCADToCSV(users: string[], idMethod: Number){
        let CADData = [];
        let totalCAD = 0;
        let paymentMethod = '';
        for (let user of users){
            if(user["currency"] == "CAD" && user['idMethod'] == idMethod){
                paymentMethod = user["paymentMethod"];
                totalCAD += Number(user["total"].replace('$','').replace(',',''));
                CADData.push({
                    "User": user["user_fullName"],
                    "Payment Method": user["paymentMethod"],
                    "Payment Method ID": user["paymentEmail"],
                    "Unique ID": user['user_id'] + '-' + user['paymentDate'].replace("-", "").replace("-", "") ,
                    "Description": "Payment for work completed",
                    "Payment Date": user["paymentDate"],
                    "Currency": user["currency"],
                    "Total Paid":user["total"]
                });
            }
        }
        CADData.push({
            "User": "Sub Total",
            "Payment Method": "",
            "Payment Method ID": "",
            "Unique ID": "",
            "Description": "",
            "Payment Date": "",
            "Currency": "CAD",
            "Total Paid":'$' + totalCAD.toLocaleString(undefined, {minimumFractionDigits: 2})
        });

        let csvData = CADData;
        downloadCSV({filename: "CAD-SummaryReport-" + paymentMethod + ".csv", data: csvData});
    }

    public exportUSDToCSV(users: string[], idMethod: Number){
        let USDData = [];
        let totalUSD = 0;
        let paymentMethod = '';

        for (let user of users){
            if(user["currency"] == "USD" && user['idMethod'] == idMethod){
                paymentMethod = user["paymentMethod"];
                totalUSD += Number(user["total"].replace('$','').replace(',',''));
                USDData.push({
                    "User": user["user_fullName"],
                    "Payment Method": user["paymentMethod"],
                    "Payment Method ID": user["paymentEmail"],
                    "Unique ID": user['user_id'] + '-' + user['paymentDate'].replace("-", "").replace("-", "") ,
                    "Description": "Payment for work completed",
                    "Payment Date": user["paymentDate"],
                    "Currency": user["currency"],
                    "Total Paid":user["total"]
                });
            }
        }

        USDData.push({
            "User": "Sub Total",
            "Payment Method": "",
            "Payment Method ID": "",
            "Unique ID": "",
            "Description": "",
            "Payment Date": "",
            "Currency": "USD",
            "Total Paid":'$' + totalUSD.toLocaleString(undefined, {minimumFractionDigits: 2})
        });
        let csvData = USDData;
        downloadCSV({filename: "USD-SummaryReport-" + paymentMethod + ".csv", data: csvData});
    }


    protected onUpdateError(requestStatus: any, responseParsed) : void{
        let msg = "error: while obtaining the data - (" + requestStatus +")";
        this.elementsList.validationsList.setSingleMessage({field: "error", "label": requestStatus, message: msg});
        window.scrollTo(0, 0);
    }



}



// WEBPACK FOOTER //
// ./js/modules/transactions_payment_summary.ts